import React,{ChangeEvent,useContext, useState} from 'react'
import Layout from '../layout/Layout'
import AuthContainer from '../features/authentication/components/AuthContainer'
import { useNavigate, useParams } from 'react-router-dom'
import Button from '../component/Button'
import Input from '../component/Input'
import axios from 'axios'
import {toast} from 'react-toastify';
import { isConfirmPassword,isPasswordValid } from '../util/middleware'
import { RouteContext } from '../context/routeContext'

function ResetPage() {
    const {token,id} = useParams();

  const {setActivePage} = useContext(RouteContext);

   // ERRORS
   const [passwordError, setPasswordError] = useState<string>("");
   const [confirmPasswordError, setConfirmPasswordError] = useState<string>("");

   
  type authUser = {password:string,confirmPassword:string}
  const navigate = useNavigate();
  const [userInput,setUserInput] = useState<authUser>({'password':'','confirmPassword':''})
  const {password,confirmPassword} = userInput;

  // const validateEmail = (value:string) => {
  //   let emailRes:(boolean|string)[] = isEmailValid(value);
  //   let isValidEmail:(boolean|string) =emailRes[0] ? emailRes[1] : "" 
  //   setEmailError(isValidEmail as string);
  // };

  const validatePassword = (value:string) => {
    let paswdRes:(boolean|string)[]= isPasswordValid(value);
    let isValidPassword:(boolean|string)  = paswdRes[0] ? paswdRes[1] : "";
    setPasswordError(isValidPassword as string);
  };
  const validateConfirmPassword = (value:{password:string,confirmPassword:string}) => {
    let cfRes:(boolean|string)[]= isConfirmPassword(value);
    let isValidPassword:(boolean|string)  = cfRes[0] ? cfRes[1] : "";
    setConfirmPasswordError(isValidPassword as string);
  };

  const handleChange = (e:ChangeEvent<HTMLInputElement>) => {
    // console.log('===============changing=============');
      e.preventDefault();
      const { value, id} = e.target;

      setUserInput((prev: authUser)=>({...prev,[id]:value}))  
      if(id==='password'){
        validatePassword(value);
      } 
      else{
        validateConfirmPassword({'password':password,'confirmPassword':value})
      } 

      }

      const handleReset = async() =>{
        // e.preventDefault();
        // console.log('==============Update Password===========');
            try {

                const newData:{password: string} = {'password':password}
                // Get Access to Signer
                // Make Function Call
                const response =await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/resetPassword/?token=${token}&&id=${id}`,newData);
                if(response.status ===200){  
                  
                setActivePage('/') ;            
                navigate('/');
                reset();
                toast.success("Password Changed!", {
                    position: toast.POSITION.TOP_CENTER
                  });
                }
                else{
                    toast.error("Couldn't update password !", {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                
            } catch (error) {
                toast.error(`${(error as any).message}`, {
                    position: toast.POSITION.TOP_LEFT
                  });                
                // console.log('My Error',error);
            }       
}

const reset = ()=>{
  setUserInput({'password':'','confirmPassword':''});
}

  return (
    <div className='h-screen w-full'>
    <Layout>
    <AuthContainer>
    <h1 className='font-bold text-center' >Update Password</h1>        
    <p className='mt-1' >New Password:</p>
    {passwordError && <p className='text-red-500' >{passwordError}</p>}
    <Input type={'password'} name={'password'} id={'password'} placeholder={'Enter password'} value={password} onChange={handleChange}></Input>
    <p className='mt-1' >Confirm New Password:</p>
    {confirmPasswordError && <p className='text-red-500' >{confirmPasswordError}</p>}
    <Input type={'password'} name={'confirmPassword'} id={'confirmPassword'} placeholder={'Enter password'} value={confirmPassword} onChange={handleChange}></Input>
    <span className='mt-4'></span>
    <Button label={'Change Password'} onClick={()=>!passwordError&&!confirmPasswordError?handleReset():null}></Button>
    </AuthContainer>
    </Layout>
  </div>
  )
}

export default ResetPage